<template>
  <div v-show="$slots.btn || showBtns.length || $slots.checked" class="mn-btns" :style="{height: height + 'px'}">
    <div
      class="btn-bor"
      :style="{height: height + 'px'}"
      :class="{'align-top': fixed, 'fixed-top': showClass}"
    >
      <slot name="btn" />
      <template v-for='(item, index) in showBtns'>
        <md-button
          v-if="!item.children"
          :key='index'
          :debounce="true"
          :icon='item.icon'
          :disabled='item.disabled'
          :style='item.style'
          :type="setPrimary(item, index)"
          :plain="item.plain"
          :loading="item.loading"
          @click='() => item.handle && item.handle(scope, item)'
        >
          {{ item.name || item.btnName }}
        </md-button>
        <md-dropdown v-else :key='index'>
          <md-button plain>
            <span>{{ item.name }}</span>
            <i class="md-icon-arrow-down"></i>
          </md-button>
          <md-dropdown-menu slot="dropdown">
            <md-dropdown-item v-for="(i, iIndex) in item.children" :key="iIndex" @click.native="() => i.handle(scope, i)">{{ i.name }}</md-dropdown-item>
          </md-dropdown-menu>
        </md-dropdown>
      </template>
      <slot name="checked" />
    </div>
  </div>
</template>
<script>
export default {
  name: 'MnBtns',
  props: {
    btnList: {
      type: Array,
      default: () => [],
    },
    // 嵌套到表格中可能用到
    scope: {
      type: Object,
      default: () => ({}),
    },
    fixed: {
      type: Boolean,
      default: false,
    },
    // 页面存在多个/不是嵌套到mn-tab的时候可以定义新名称
    fixedName: {
      type: String,
      default: '.md-btn-fixed',
    },
    height: {
      type: Number,
      default: 54,
    },
    // 是否最后一个按钮类型为primary 默认否
    lastPrimary: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showClass: false,
    };
  },
  computed: {
    // 主要用于判断按钮为空不展示
    showBtns() {
      const showBtns = [];
      this.btnList.forEach((item) => {
        if (!item.show || item.show(this.scope.row)) {
          showBtns.push(item);
        }
      });
      this.$nextTick(() => {
        try {
          this.$parent.heightReset();
        } catch (e) {
          //
        }
      });

      return showBtns;
    },
  },
  methods: {
    // 按钮type设置
    setPrimary(item, index) {
      let type = item.type;
      const primaryIndex = this.lastPrimary ? this.showBtns.length - 1 : 0;
      if (index === primaryIndex && !type) {
        type = 'primary';
      }
      return type;
    },
    // 按钮需要悬浮则需要把父级传进来(默认.md-btn-fixed)
    handleScroll() {
      let scrollbarEl = document.querySelector(this.fixedName);
      try {
        const scrollElement = scrollbarEl.querySelector('.el-scrollbar__wrap');
        if (scrollElement.getAttribute('class') === 'el-scrollbar__wrap') {
          scrollbarEl = scrollElement;
        }
      } catch (e) {
        // try 防止指向其他el-select
      }
      scrollbarEl && (scrollbarEl.onscroll = () => {
        this.showClass = scrollbarEl.scrollTop > 0;
      });
    },
  },
  mounted() {
    // 页面渲染完成再绑定onscroll
    this.$nextTick(() => {
      this.fixed && this.handleScroll();
    });
  },
};
</script>
<style lang="less" scoped>
.mn-btns {
  /deep/.btn-bor {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    transition: box-shadow .3s linear;
    box-shadow: 0 0 0 0 #fff;
    &.align-top {
      align-items: flex-start;
    }
    &.fixed-top {
      position: absolute;
      top: 0;
      left: 0;
      background: #fff;
      box-shadow: 0 8px 16px -12px #c0c0c0;
      z-index: 10;
    }
    .md-button + .md-dropdown, .md-dropdown + .md-button {
      margin-left: 8px;
    }
    >div:first-child{
      margin-right: 8px;
    }
  }
  // 新表单底部悬浮按钮
  &.mn-form-bottom-btns {
    height: 56px;
    > div {
      position: fixed;
      z-index: 9;
      box-shadow:0 0 8px #a9a2a26e;
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      -webkit-box-pack: end;
      -ms-flex-pack: end;
      justify-content: flex-end;
      background: #fff;
      line-height: 56px;
      height: 56px;
      width: 100%;
      left: 0;
      bottom: 0;
      padding: 0 30px;
    }
  }
}

</style>
